<div class="list-container mat-elevation-z8">
    <div class="loading-shade"
         *ngIf="isLoadingResults">
      <mat-spinner *ngIf="isLoadingResults"></mat-spinner>

    </div>
    <h1>Your Businesses <button mat-button class="inline-button" (click)="addBusiness()"><mat-icon>note_add</mat-icon></button></h1>
    <div class="table-container">
  
      <table mat-table [dataSource]="filteredAndPaged" class="table" matSort
             matSortActive="created" matSortDisableClear matSortDirection="desc"
             (matSortChange)="resetPaging()">

  

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Name</th>
          <td mat-cell *matCellDef="let row"><a [routerLink]="['/retailers/',  row.id]">{{row.name||"Untitled"}}</a></td>
        </ng-container>
  

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear># Locations</th>
          <td mat-cell *matCellDef="let row">{{row.locations.length}}</td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  
    <mat-paginator [pageSize]="30"></mat-paginator>
  </div>